import {create} from "zustand";

export const useModalStore = create((set) => ({
    // Модальное окно "Все фильтры"
    searchFiltersDrawerFlag: false,

    /**
     * Открыть модальное окно "Все фильтры"
     */
    openSearchFiltersDrawer: () => set({searchFiltersDrawerFlag: true}),
    /**
     * Закрыть модальное окно "Все фильтры"
     */
    closeSearchFiltersDrawer: () => set({searchFiltersDrawerFlag: false}),
}));
